"use strict";

exports.__esModule = true;
var _DashboardToolbar = require("./DashboardToolbar");
Object.keys(_DashboardToolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardToolbar[key]) return;
  exports[key] = _DashboardToolbar[key];
});